import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '@/components/Button';
import LifelineShape from '@/components/LifelineShape';
import classnames from 'classnames';

import './style.css';

function Claim({ visible, beaconIndex, lifelineData = null, onButtonFocus }) {
  const [showLifeline, setShowLifeline] = useState(false);

  useEffect(() => {
    let timeout;

    if (lifelineData && !showLifeline) {
      timeout = setTimeout(() => {
        setShowLifeline(true);
      }, 100);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [lifelineData]);

  return (
    <div
      data-index={beaconIndex}
      className={classnames('section', 'claim', {
        'section--visible': visible,
      })}
    >
      <div /* BEACON */ data-index={beaconIndex} className="beacon" />
      {lifelineData && (
        <LifelineShape
          data={lifelineData}
          animateOnMouseMove={false}
          transparent
          cloud={false}
          className={classnames('big-shape', {
            'big-shape--visible': showLifeline,
          })}
          paused={!visible}
        />
      )}

      <div className="content-container">
        <div className="title-container fade-in">
          <h1>
            Memories is a place to celebrate lives, <br />
            share stories and remember loved ones.
          </h1>
        </div>

        <div className="buttons-wrapper fade-in td1">
          <Button
            size="large"
            variant="tertiary"
            to="/add-lifeline"
            onFocus={() => {
              onButtonFocus(beaconIndex);
            }}
          >
            Start creating a lifeline
          </Button>
        </div>
      </div>
    </div>
  );
}

Claim.propTypes = {
  visible: PropTypes.bool.isRequired,
  beaconIndex: PropTypes.number.isRequired,
  lifelineData: PropTypes.object,
};

export default Claim;
